module.exports = __webpack_public_path__ + "a71679d3c2557e7175ed39f7f098d75c.pdf";